module.exports = __webpack_public_path__ + "static/partici-hero-358ca8f300df46f245b455dfa7e552f3.jpg";